import { Heading } from "../Heading"
import { Text } from "../Text"
import { TimelineHeaderProps } from "./types"

/**
 * Displays the title and subtitle for a milestone
 *   Default: Pre-styled title and subtitle
 *   Alternative: A fully custom component for complete flexibility
 *
 * @component
 * @example
 * <Timeline.Header title="Title" subtitle="Subtitle" />
 *
 * <Timeline.Header>
 *   <p>Custom header</p>
 * </Timeline.Header>
 */
export const TimelineHeader = ({
  title,
  subtitle,
  children,
  className,
  ...rest
}: TimelineHeaderProps) => {
  return (
    <header className={className} {...rest}>
      {title && (
        <Heading as="h2" size="lg" className="!tracking-tight !text-md !font-medium">
          {title}
        </Heading>
      )}
      {subtitle && (
        <Text size="small" className="tracking-tight text-gray-400">
          {subtitle}
        </Text>
      )}
      {children}
    </header>
  )
}

TimelineHeader.displayName = "TimelineHeader"
